/* ═══════════════════════════════════════════════════════════════
   PAKEEZAH — Animation & Interaction Engine v4
   Bold & Vibrant · Pink × Purple × Gold
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TOUCH   = !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function qs(s, c)  { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function io(els, fn, opts) {
    if (!els.length) return;
    if (!window.IntersectionObserver) { els.forEach(fn); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { fn(e.target); obs.unobserve(e.target); } });
    }, opts || { threshold: 0.12 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* 1. PAGE CURTAIN ─────────────────────────────────── */
  function initCurtain() {
    var curtain = document.createElement('div');
    curtain.id = 'pk-curtain';
    document.body.prepend(curtain);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        curtain.classList.add('exit');
        curtain.addEventListener('animationend', function () {
          curtain.remove();
          document.body.classList.add('pk-ready');
        }, { once: true });
      });
    });
  }

  /* 2. SCROLL PROGRESS ──────────────────────────────── */
  function initProgress() {
    var bar = document.createElement('div'); bar.id = 'pk-progress';
    document.body.prepend(bar);
    window.addEventListener('scroll', function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (max > 0 ? window.scrollY / max * 100 : 0).toFixed(1) + '%';
    }, { passive: true });
  }

  /* 3. LUXURY CURSOR ────────────────────────────────── */
  function initCursor() {
    if (TOUCH) return;
    var dot  = document.createElement('div'); dot.id  = 'pk-dot';
    var ring = document.createElement('div'); ring.id = 'pk-ring';
    document.body.append(dot, ring);
    var mx = -200, my = -200, rx = -200, ry = -200;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px'; dot.style.top = my + 'px';
    });
    (function loop() {
      rx = lerp(rx, mx, 0.13); ry = lerp(ry, my, 0.13);
      ring.style.left = rx.toFixed(1) + 'px'; ring.style.top = ry.toFixed(1) + 'px';
      requestAnimationFrame(loop);
    })();
    var T = 'a,button,.product-card,.category-card,.arrival-card,.blindbag-card,.offer-card,.picker-item,.filter-btn,[role="button"]';
    document.addEventListener('mouseover',  function (e) { if (e.target.closest(T)) ring.classList.add('hover'); });
    document.addEventListener('mouseout',   function (e) { if (e.target.closest(T)) ring.classList.remove('hover'); });
    document.addEventListener('mousedown',  function () { ring.classList.add('click'); });
    document.addEventListener('mouseup',    function () { ring.classList.remove('click'); });
  }

  /* 4. HEADER SCROLL ────────────────────────────────── */
  function initHeader() {
    var h = qs('.site-header');
    if (!h) return;
    window.addEventListener('scroll', function () { h.classList.toggle('scrolled', window.scrollY > 40); }, { passive: true });
  }

  /* 5. MOBILE MENU ──────────────────────────────────── */
  function initMobileMenu() {
    var btn = qs('.mobile-menu-btn'), menu = qs('.mobile-menu');
    if (!btn || !menu) return;
    btn.addEventListener('click', function () { menu.classList.toggle('open'); });
  }

  /* 6. SCROLL REVEAL ────────────────────────────────── */
  function initReveal() {
    ['.categories-grid','.products-grid','.promo-features-grid',
     '.arrivals-scroll','.blindbag-cards','.offers-cards','.blog-items-grid','.footer-grid'
    ].forEach(function (s) { var el = qs(s); if (el) el.classList.add('reveal-stagger'); });
    io(qsa('.reveal'), function (el) { el.classList.add('visible'); }, { threshold: 0.1 });
  }

  /* 7. HERO MOUSE PARALLAX ──────────────────────────── */
  function initHeroParallax() {
    if (REDUCED || TOUCH) return;
    var hero  = qs('.hero'); if (!hero) return;
    var cards = qsa('.hero__card--main,.hero__card--secondary,.hero__card--small', hero);
    var badge = qs('.hero__float-badge', hero);
    var review = qs('.hero__review-card', hero);
    var depths = [14, 22, 30];
    var cx = [0,0,0], cy = [0,0,0], bx = 0, by = 0, rvx = 0, rvy = 0;
    var active = false, hx = 0, hy = 0;
    hero.addEventListener('mouseenter', function () { active = true; hero.classList.add('hero--active'); });
    hero.addEventListener('mouseleave', function () {
      active = false; hero.classList.remove('hero--active');
      cards.forEach(function (c) { c.style.transform = ''; });
      if (badge)  badge.style.transform  = '';
      if (review) review.style.transform = '';
    });
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      hx = (e.clientX - r.left) / r.width  - 0.5;
      hy = (e.clientY - r.top)  / r.height - 0.5;
    });
    (function loop() {
      if (active) {
        cards.forEach(function (card, i) {
          cx[i] = lerp(cx[i], hx * depths[i], 0.07);
          cy[i] = lerp(cy[i], hy * depths[i], 0.07);
          card.style.transform = 'translate(' + cx[i].toFixed(2) + 'px,' + cy[i].toFixed(2) + 'px)';
        });
        if (badge) { bx = lerp(bx, hx*-18, 0.06); by = lerp(by, hy*-18, 0.06); badge.style.transform = 'translate('+bx.toFixed(2)+'px,'+by.toFixed(2)+'px)'; }
        if (review){ rvx = lerp(rvx, hx*-10, 0.05); rvy = lerp(rvy, hy*-10, 0.05); review.style.transform = 'translate('+rvx.toFixed(2)+'px,'+rvy.toFixed(2)+'px) rotate(-2deg)'; }
      }
      requestAnimationFrame(loop);
    })();
  }

  /* 8. GOLD PARTICLES ───────────────────────────────── */
  function initParticles() {
    if (REDUCED) return;
    var canvas = qs('#pk-particles'); if (!canvas) return;
    var ctx = canvas.getContext('2d'), W, H, P = [];
    var COLORS = ['#F72585','#7209B7','#F8C537','#FF6B6B','#9D4EDD','#FF70B8'];
    function resize() { W = canvas.width = canvas.parentElement.offsetWidth; H = canvas.height = canvas.parentElement.offsetHeight; }
    resize();
    window.addEventListener('resize', resize, { passive: true });
    for (var i = 0; i < 35; i++) {
      P.push({ x: Math.random()*800, y: Math.random()*600, r: Math.random()*2.4+0.4,
               vx: (Math.random()-0.5)*0.3, vy: -Math.random()*0.35-0.1,
               a: Math.random()*0.5+0.15, c: COLORS[i%COLORS.length] });
    }
    (function draw() {
      ctx.clearRect(0,0,W,H);
      P.forEach(function(p) {
        ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
        ctx.fillStyle=p.c; ctx.globalAlpha=p.a; ctx.fill();
        p.x+=p.vx; p.y+=p.vy;
        if(p.y<-8) p.y=H+8; if(p.x<-8) p.x=W+8; if(p.x>W+8) p.x=-8;
      });
      ctx.globalAlpha=1;
      requestAnimationFrame(draw);
    })();
  }

  /* 9. 3D TILT ──────────────────────────────────────── */
  function initTilt() {
    if (REDUCED || TOUCH) return;
    qsa('.product-card__inner,.category-card,.arrival-card,.blindbag-card,.offer-card,.promo-feature,.blog-item-card').forEach(function (c) {
      if (c.dataset.tilt) return; c.dataset.tilt='1'; c.classList.add('pk-tilt');
      if (getComputedStyle(c).position==='static') c.style.position='relative';
      var sh=document.createElement('div'); sh.className='pk-shine'; c.appendChild(sh);
      c.addEventListener('mousemove', function(e) {
        var r=c.getBoundingClientRect(), xp=(e.clientX-r.left)/r.width, yp=(e.clientY-r.top)/r.height;
        c.style.setProperty('--tx',(-(yp-.5)*14).toFixed(2)+'deg');
        c.style.setProperty('--ty', ((xp-.5)*14).toFixed(2)+'deg');
        c.style.setProperty('--ts','1.03');
        c.style.setProperty('--sx',(xp*100).toFixed(1)+'%');
        c.style.setProperty('--sy',(yp*100).toFixed(1)+'%');
        c.classList.remove('reset');
      });
      c.addEventListener('mouseleave', function() {
        c.classList.add('reset');
        c.style.setProperty('--tx','0deg'); c.style.setProperty('--ty','0deg'); c.style.setProperty('--ts','1');
      });
    });
  }

  /* 10. HOVER GLOW ──────────────────────────────────── */
  function initGlow() {
    qsa('.product-card,.category-card,.arrival-card').forEach(function (c) {
      if (c.dataset.glow) return; c.dataset.glow='1'; c.classList.add('pk-glow');
      c.addEventListener('mousemove', function(e) {
        var r=c.getBoundingClientRect();
        c.style.setProperty('--gx',((e.clientX-r.left)/r.width*100).toFixed(1)+'%');
        c.style.setProperty('--gy',((e.clientY-r.top)/r.height*100).toFixed(1)+'%');
      });
    });
  }

  /* 11. CLICK RIPPLE ────────────────────────────────── */
  function initRipple() {
    if (REDUCED) return;
    document.addEventListener('click', function(e) {
      var btn=e.target.closest('.btn-primary,.btn-gold,.btn-hero-primary,.newsletter-btn,.blindbag-card__cta,.offer-card__cta,.add-btn,.filter-btn,.customize-panel__cta');
      if (!btn) return;
      var r=btn.getBoundingClientRect(), sz=Math.max(r.width,r.height);
      var rip=document.createElement('span'); rip.className='pk-ripple';
      rip.style.cssText='width:'+sz+'px;height:'+sz+'px;left:'+(e.clientX-r.left-sz/2)+'px;top:'+(e.clientY-r.top-sz/2)+'px';
      if(getComputedStyle(btn).position==='static') btn.style.position='relative';
      btn.appendChild(rip);
      rip.addEventListener('animationend', function(){ rip.remove(); }, {once:true});
    });
  }

  /* 12. COUNT-UP ────────────────────────────────────── */
  function initCountUp() {
    io(qsa('[data-countup]'), function(el) {
      var target=parseInt(el.dataset.countup,10), suffix=el.dataset.suffix||'', dur=1800, start=null;
      function step(ts) {
        if(!start) start=ts;
        var p=Math.min((ts-start)/dur,1), ease=1-Math.pow(1-p,3);
        el.textContent=Math.floor(ease*target)+suffix;
        if(p<1) requestAnimationFrame(step);
        else el.classList.add('pop');
      }
      requestAnimationFrame(step);
    }, {threshold:0.5});
  }

  /* 13. HORIZONTAL SCROLL ───────────────────────────── */
  function initHScroll() {
    qsa('.hscroll-container').forEach(function(container) {
      var track=qs('.hscroll-track',container), panels=qsa('.hscroll-panel',container);
      var dots=qsa('.hscroll-dot',container), arrows=qs('.hscroll-arrows',container);
      var counter=qs('.hscroll-counter',container), n=panels.length;
      if(!track||n<2) return;
      function isMobile(){ return window.innerWidth<=768; }
      if(isMobile()) {
        track.addEventListener('scroll', function(){
          var idx=Math.round(track.scrollLeft/window.innerWidth);
          dots.forEach(function(d,i){ d.classList.toggle('active',i===idx); });
          if(counter) counter.textContent='0'+(idx+1)+' / 0'+n;
        }, {passive:true}); return;
      }
      var curX=0;
      (function tick() {
        if(isMobile()) return;
        var rect=container.getBoundingClientRect(), scrollable=rect.height-window.innerHeight;
        var raw=scrollable>0?-rect.top/scrollable:0, progress=Math.max(0,Math.min(1,raw));
        var targetX=-progress*(n-1)*window.innerWidth;
        curX+=(targetX-curX)*0.09;
        track.style.transform='translateX('+curX+'px)';
        var active=Math.round(progress*(n-1));
        dots.forEach(function(d,i){ d.classList.toggle('active',i===active); });
        if(arrows) arrows.style.opacity=active<n-1?'1':'0';
        if(counter) counter.textContent='0'+(active+1)+' / 0'+n;
        requestAnimationFrame(tick);
      })();
      window.addEventListener('resize', function(){ if(isMobile()){ track.style.transform=''; curX=0; } });
    });
  }

  /* 14. PRODUCT FILTER ──────────────────────────────── */
  function initFilter() {
    qsa('.filter-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        qsa('.filter-btn').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        var cat=btn.dataset.filter;
        qsa('.product-card[data-category]').forEach(function(card) {
          var show=cat==='all'||card.dataset.category===cat;
          card.style.display=show?'':'none';
          if(show) { card.style.opacity='0'; card.style.transform='translateY(20px)'; setTimeout(function(){ card.style.transition='opacity .4s ease, transform .4s ease'; card.style.opacity='1'; card.style.transform=''; },10); }
        });
      });
    });
  }

  /* 15. ADD TO CART (real, AJAX) ────────────────────── */
  var CHECK_SVG='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  function refreshCartCount(count) {
    var cc=qs('.cart-count');
    if(cc) { cc.textContent=count; cc.classList.remove('bounce'); void cc.offsetWidth; cc.classList.add('bounce'); }
    else { var cb=qs('.cart-btn'); if(cb){ var s=document.createElement('span'); s.className='cart-count'; s.textContent=count; cb.appendChild(s); } }
  }
  function initCart() {
    document.addEventListener('click', function(e) {
      var btn=e.target.closest('.js-quick-add'); if(!btn) return;
      e.preventDefault();
      var id=btn.getAttribute('data-variant-id'); if(!id||btn.classList.contains('added')) return;
      var original=btn.innerHTML;
      btn.classList.add('added'); btn.innerHTML=CHECK_SVG+' Added';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:id,quantity:1})})
        .then(function(r){ if(!r.ok) throw new Error('add'); return fetch('/cart.js',{headers:{'Accept':'application/json'}}); })
        .then(function(r){ return r.json(); })
        .then(function(cart){ refreshCartCount(cart.item_count); setTimeout(function(){ btn.classList.remove('added'); btn.innerHTML=original; },1500); })
        .catch(function(){ btn.classList.remove('added'); btn.innerHTML=original; window.location.href='/cart'; });
    });
  }

  /* 16. WISHLIST (visual only, emoji-free) ───────────── */
  function initWishlist() {
    document.addEventListener('click', function(e) {
      var btn=e.target.closest('.product-card__wishlist'); if(!btn) return;
      e.preventDefault();
      btn.classList.toggle('active');
    });
  }

  /* 17. CUSTOMIZE PICKER ────────────────────────────── */
  function initPicker() {
    var picker=qs('.product-picker__grid'), fill=qs('.customize-panel__progress-fill');
    var cnt=qs('.customize-progress-count'), cta=qs('.customize-cta'), MAX=6, selected={};
    if(!picker) return;
    picker.addEventListener('click', function(e) {
      var item=e.target.closest('.picker-item'); if(!item||item.disabled) return;
      var id=item.dataset.id;
      if(selected[id]) { delete selected[id]; item.classList.remove('selected'); var chk=item.querySelector('.picker-item__check'); if(chk) chk.remove(); }
      else if(Object.keys(selected).length<MAX) {
        selected[id]=true; item.classList.add('selected');
        if(!item.querySelector('.picker-item__check')) { var c=document.createElement('div'); c.className='picker-item__check'; c.innerHTML='<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>'; item.appendChild(c); }
      }
      var n=Object.keys(selected).length;
      qsa('.picker-item',picker).forEach(function(i){ i.disabled=!selected[i.dataset.id]&&n>=MAX; });
      if(fill) fill.style.width=(n/MAX*100)+'%';
      if(cnt)  cnt.textContent=n+' / '+MAX;
      if(cta) {
        if(n===MAX) { cta.textContent='📱 Order via WhatsApp'; cta.style.background='var(--grad-primary)'; cta.style.opacity='1'; cta.style.pointerEvents='auto'; }
        else { cta.textContent='Select '+(MAX-n)+' more item'+(MAX-n!==1?'s':''); cta.style.background='rgba(255,255,255,0.1)'; cta.style.opacity='0.5'; cta.style.pointerEvents='none'; }
      }
    });
  }

  /* 18. NEWSLETTER ──────────────────────────────────── */
  function initNewsletter() {
    var form=qs('.newsletter-form'); if(!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      form.innerHTML='<div style="display:inline-flex;align-items:center;gap:8px;padding:14px 28px;background:var(--grad-primary);color:white;border-radius:999px;font-weight:700;font-size:13px;animation:fadeUp .4s ease forwards"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> You\'re on the list!</div>';
    });
  }

  /* 19. SMOOTH ANCHOR SCROLL ────────────────────────── */
  function initAnchors() {
    document.addEventListener('click', function(e) {
      var a=e.target.closest('a[href^="#"]'); if(!a) return;
      var target=document.querySelector(a.getAttribute('href')); if(!target) return;
      e.preventDefault();
      var h=qs('.site-header'), offset=h?h.offsetHeight:0;
      window.scrollTo({top:target.getBoundingClientRect().top+window.scrollY-offset-16, behavior:'smooth'});
    });
  }

  /* 20. MAGNETIC BUTTONS ────────────────────────────── */
  function initMagnetic() {
    if(REDUCED||TOUCH) return;
    qsa('.btn-primary,.btn-gold,.btn-hero-primary').forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        var r=btn.getBoundingClientRect(), dx=(e.clientX-(r.left+r.width/2))*0.22, dy=(e.clientY-(r.top+r.height/2))*0.22;
        btn.style.transform='translate('+dx.toFixed(2)+'px,'+dy.toFixed(2)+'px) translateY(-2px)';
      });
      btn.addEventListener('mouseleave', function(){ btn.style.transform=''; });
    });
  }

  /* 21. NAV STAGGER ─────────────────────────────────── */
  function initNavStagger() {
    if(REDUCED) return;
    qsa('.nav-links a').forEach(function(link,i) {
      link.style.cssText='opacity:0;transform:translateY(-10px);transition:opacity .4s ease '+(0.15+i*.07)+'s,transform .4s ease '+(0.15+i*.07)+'s';
      requestAnimationFrame(function(){ requestAnimationFrame(function(){ link.style.opacity='1'; link.style.transform='translateY(0)'; }); });
    });
  }

  /* INIT ────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function() {
    if(!REDUCED) initCurtain(); else document.body.classList.add('pk-ready');
    initProgress();
    initCursor();
    initHeader();
    initMobileMenu();
    initReveal();
    initHeroParallax();
    initParticles();
    initTilt();
    initGlow();
    initRipple();
    initCountUp();
    initHScroll();
    initFilter();
    initCart();
    initWishlist();
    initPicker();
    initNewsletter();
    initAnchors();
    initMagnetic();
    initNavStagger();
  });
})();
